import { VISIBILITY_TYPE } from "../common/constants";
import { _isIsolated } from "./actions";
import { diagram } from "./initial";
import { _recalculateActualRelationsCount } from "./relationCountActions";

function _setVisibility(part, value) {
    diagram.nodeDiagram.model.setDataProperty(part.data, 'Visibility', value);
}

function _getVisibleNodesData() {
    const visibleNodesData = [];
    const it = diagram.nodeDiagram.nodes.iterator;
    while (it.next()) {
        const node = it.value;
        if (node.visible) {
            visibleNodesData.push(node.data);
        }
    }
    return visibleNodesData;
}

function _getVisibleRelationsData() {
    const visibleLinksData = [];
    const it = diagram.nodeDiagram.links.iterator;
    while (it.next()) {
        const link = it.value;
        if (link.visible && link.fromNode.visible && link.toNode.visible) {
            visibleLinksData.push(link.data);
        }
    }
    return visibleLinksData;
}

// COLLAPSE

function _collapseLevel(elem, startingNode, parent, visibilityType) {
    var anyFollowing = _getConnectedData(elem.node, 'chld').filter(function (c) { return parent === null || c.node.data.EntityID !== parent.node.data.EntityID });
    var parents = _getConnectedData(elem.node, 'prnt');

    if (anyFollowing.length > 0 && (startingNode || parents.filter((p) => p.node.data.EntityID !== parent.node.data.EntityID).length === 0)) {
        var nextLevel = anyFollowing.filter(af => af.node.isVisible() && af.node.data.OriginalLevel > elem.node.data.OriginalLevel);
        var myLevel = anyFollowing.filter(af => af.node.isVisible() && af.node.data.OriginalLevel === elem.node.data.OriginalLevel);

        if (nextLevel.length > 0) {
            nextLevel.forEach(val => _collapseLevel(val, false, elem, visibilityType));
        }

        if (myLevel.length > 0) {
            myLevel.forEach(val => {
                if (val.data.isVisible()) {
                    _setVisibility(val.data, visibilityType);
                }
                if (val.node.isVisible()) {
                    parents = _getConnectedData(val.node, 'prnt');
                    if (parents.filter((p) => p.node.data.EntityID !== elem.node.data.EntityID).length === 0) {
                        _collapseLevel(val, false, elem, visibilityType);
                    }
                }
            });
        }
    }

    if (!startingNode) {
        if (elem.node.isVisible()) {
            parents = _getConnectedData(elem.node, 'prnt');
            if (parents.filter((p) => p.node.data.EntityID !== parent.node.data.EntityID).length === 0 && anyFollowing.filter(af => af.data.isVisible()).length === 0) {
                _setVisibility(elem.node, visibilityType);
            }
            // else {
            var connections = elem.node.linksConnected;
            while (connections.next()) {
                var fromNode = connections.value.fromNode;
                var toNode = connections.value.toNode;
                var nextNode = fromNode.data === elem.node.data ? toNode : toNode.data === elem.node.data ? fromNode : null;
                if (nextNode !== null && nextNode.data.OriginalLevel < elem.node.data.OriginalLevel && nextNode.data.EntityID === parent.node.data.EntityID) {
                    _setVisibility(connections.value, visibilityType);
                }
            }
            // }
        }
    }

    if (elem.node.data.customRelationsAdded !== undefined) {
        elem.node.data.RelationsCount += elem.node.data.customRelationsAdded;
        elem.node.data.customRelationsAdded = undefined;
    }
}

function _getConnectedData(myNode, type) {
    var connections = myNode.linksConnected;
    var result = [];

    while (connections.next()) {
        if (connections.value.visible) {
            var fromNode = connections.value.fromNode;
            var toNode = connections.value.toNode;

            var nextNode = fromNode.data === myNode.data ? toNode : toNode.data === myNode.data ? fromNode : null;

            if (type === 'chld' && nextNode !== null && nextNode.data.OriginalLevel >= myNode.data.OriginalLevel) {
                result.push({ name: nextNode.data.Name, lvl: nextNode.data.OriginalLevel, data: connections.value, node: nextNode });
            }
            else if (type === 'prnt' && nextNode !== null && nextNode.data.OriginalLevel < myNode.data.OriginalLevel) {
                result.push({ name: nextNode.data.Name, lvl: nextNode.data.OriginalLevel, data: connections.value, node: nextNode });
            }
        }
    }

    return result;
}

// EXPAND

function _expandSubTree(node, parent) {
    var subTreeRootLinks = node.linksConnected;
    while (subTreeRootLinks.next()) {
        const link = subTreeRootLinks.value;
        if (link.fromNode.data === node.data) {
            _expandNodeSubTree(link, link.toNode, node, parent);
        } else if (link.toNode.data === node.data) {
            _expandNodeSubTree(link, link.fromNode, node, parent);
        }
    }
}

function _expandNodeSubTree(link, otherNode, node, parent) {
    if (otherNode.data.OriginalLevel >= node.data.OriginalLevel) {
        if (otherNode.data.IsExpanded && (parent === null || otherNode.data.EntityID !== parent.data.EntityID)) {
            _expandSubTree(otherNode, node);
        }
        _setVisibility(link, VISIBILITY_TYPE.visible);
        const canShow = _canShowNode(otherNode);
        if (!otherNode.visible && canShow) {
            _setVisibility(otherNode, VISIBILITY_TYPE.visible);
        }
    }
}

function _canShowNode(node) {
    var connLinks = node.linksConnected;
    while (connLinks.next()) {
        if (connLinks.value.visible) {
            return true;
        }
    }
    return false;
}

// CONDITIONS

function _hasAnyDeletedPart() {
    const nodeIterator = diagram.nodeDiagram.nodes;
    while (nodeIterator.next()) {
        const node = nodeIterator.value;
        if (node.data.Visibility === VISIBILITY_TYPE.deleted) {
            return true;
        }
    }

    const linkIterator = diagram.nodeDiagram.links;
    while (linkIterator.next()) {
        const link = linkIterator.value;
        if (link.data.Visibility === VISIBILITY_TYPE.deleted) {
            return true;
        }
    }

    return false;
}

function _hasDeletedDescendant(node) {
    if (!node) return false;

    function checkDescendants(part, visitedNodes) {
        if (visitedNodes.has(part))
            return false;
        visitedNodes.add(part);

        if (part.data.Visibility === VISIBILITY_TYPE.deleted) {
            return true;
        }

        const connections = part.linksConnected;
        while (connections.next()) {
            const link = connections.value;
            const otherNode = link.getOtherNode(part.node);
            if (otherNode.data.OriginalLevel >= part.data.OriginalLevel) {
                if (link.data.Visibility === VISIBILITY_TYPE.deleted) {
                    return true;
                }
            }
        }

        const nodesConnected = part.findNodesConnected();
        while (nodesConnected.next()) {
            const otherNode = nodesConnected.value;
            if (otherNode.data.OriginalLevel >= part.data.OriginalLevel && checkDescendants(otherNode, visitedNodes)) {
                return true;
            }
        }

        return false;
    }

    return checkDescendants(node, new Set());
}

// DELETE

function _deleteNode(part) {
    // Delete connections to parent nodes
    const connections = part.linksConnected;
    while (connections.next()) {
        const link = connections.value;
        const otherNode = link.getOtherNode(part.node);
        if (otherNode.data.OriginalLevel < part.data.OriginalLevel) {
            _setVisibility(link, VISIBILITY_TYPE.deleted);
        }
    }
    // Delete connections to subtree nodes
    _collapseLevel({ node: part }, true, null, VISIBILITY_TYPE.deleted);
    // Delete the node itself
    _setVisibility(part, VISIBILITY_TYPE.deleted);
    _recalculateActualRelationsCount(part);
}

function _deleteRelation(part) {
    // Set the visibility of the current part to deleted
    _setVisibility(part, VISIBILITY_TYPE.deleted);

    const fromNode = part.fromNode;
    const toNode = part.toNode;

    if (_isIsolated(fromNode, part)) {
        // Collapse the fromNode's subtree
        _collapseLevel({ node: fromNode }, true, null, VISIBILITY_TYPE.deleted);
        // Set the visibility of the fromNode
        _setVisibility(fromNode, VISIBILITY_TYPE.deleted);
    }
    if (_isIsolated(toNode, part)) {
        // Set the visibility of the toNode
        _setVisibility(toNode, VISIBILITY_TYPE.deleted);
        // Collapse the toNode's subtree
        _collapseLevel({ node: toNode }, true, null, VISIBILITY_TYPE.deleted);
    }

    _recalculateActualRelationsCount(fromNode);
    _recalculateActualRelationsCount(toNode);
}

export { _collapseLevel, _deleteNode, _deleteRelation, _expandSubTree, _canShowNode, _getVisibleNodesData, _getVisibleRelationsData, _hasAnyDeletedPart, _hasDeletedDescendant, _setVisibility };

